module.exports = __webpack_public_path__ + "static/media/logos_squares_Sup_HKUST.af975cc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Sup_HKUST.png
// module id = 70
// module chunks = 0